import { styled } from '@linaria/react'
import { COLOR, MEDIA } from 'vars/index'

export const HintsArrowButtonSC = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;

  & svg {
    color: var(${COLOR.TEXT_ICON_SECONDARY});
  }

  ${MEDIA.NO_TOUCH} {
    &:hover,
    &:hover svg {
      color: var(${COLOR.TEXT_ICON_PRIMARY});
    }
  }
`
